import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData } from '../../types'
import { CmsConverterService } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SeparatorConverter extends CmsConverterService<SeparatorData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      padding: formData.st_separator_padding?.value?.identifier ?? '',
      paddingMobile: formData.st_separator_padding_mobile?.value?.identifier ?? '',
      paddingTablet: formData.st_separator_padding_tablet?.value?.identifier ?? '',
      backgroundColor: formData.st_backgroundcolor?.value?.identifier ?? '',
      fullWidth: formData.st_full_width?.value ?? false
    }
  }
}

export const SEPARATOR_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SeparatorData>>('SeparatorConverter')

export interface SeparatorData extends ConvertedComponentData {
  padding: string;
  paddingMobile: string;
  paddingTablet: string;
  backgroundColor: string;
  fullWidth: boolean;
}
